/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { ActionButton, Text, Typography } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { State } from '../../../../redux';

import { enterpriseColors } from '../../../../style/colors';
import { NotaryTasksModal } from './NotaryTasksModal';

const styles = StyleSheet.create({
  wrapper: {
    ...Typography.Roboto(),
    color: enterpriseColors.NEUTRAL_800,
    padding: '20px 20px',
    maxWidth: 600,
    border: `1px solid ${enterpriseColors.NEUTRAL_200}`,
    borderRadius: 6,
    backgroundColor: enterpriseColors.WHITE,
    marginTop: 12,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  statusCard: {
    color: enterpriseColors.NEUTRAL_700,
    margin: 7,
    fontSize: 14,
  },
  buttonWrapper: {
    minWidth: 120,
  },
});

export interface NotaryTasks {
  ['Lender Documents']?: string;
  ['Title Documents']?: string;
}

export namespace NotaryTasksCard {
  export interface Props {
    roomId: string;
  }
}

export const NotaryTasksCard: React.FC<NotaryTasksCard.Props> = ({ roomId }) => {
  const { roomDetail } = useSelector((state: State) => state);
  const notaryTasks = roomDetail.notaryTasks;
  const [NotaryTasksModalOpen, setNotaryTasksModalOpen] = useState(false);

  return (
    <div>
      <div className={css(styles.wrapper)} data-it="NotaryStatusCard">
        <div>
          {notaryTasks.map(task => {
            return (
              <div key={task.id} data-it={`notaryTaskDescription-${task.id}`} className={css(styles.statusCard)}>
                <Text weight="semibold">{task.name}: </Text>
                <Text>{task.status}</Text>
              </div>
            );
          })}
        </div>
        <div className={css(styles.buttonWrapper)}>
          <ActionButton
            data-dd-privacy="allow"
            data-it="notaryTaskEditButton"
            btnSize="md"
            label="Edit"
            type="button"
            onClick={() => setNotaryTasksModalOpen(true)}
            isFullWidth={true}
          />
        </div>
      </div>
      {NotaryTasksModalOpen && (
        <NotaryTasksModal
          data-it="notaryTaskEditModal"
          headerText="Edit Documents Status"
          tasks={notaryTasks}
          roomId={roomId}
          handleClose={() => setNotaryTasksModalOpen(false)}
        />
      )}
    </div>
  );
};
